import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PARA_SCORE_RUBRIC } from '../../models/para-score-rubric.const';
import { paraScoreFillHex, paraScoreTextHex, paraScoreTintHex } from '../../utils/para-score-style.util';

@Component({
	selector: 'app-stored-score-row',
	templateUrl: './stored-score-row.component.html',
	styleUrls: ['./stored-score-row.component.css'],
})
export class StoredScoreRowComponent implements OnInit {
	@Input() assessment: any;
	@Input() storageKey: string;
	@Input() allowDelete = false;
	@Input() allowRescore = false;
	@Output() deleteScore = new EventEmitter<string>();
	@Output() rescore = new EventEmitter<string>();

	private resolveAssessmentTemplateId(): string | number | null {
		return this.assessment?.question?.assessmentTemplateId ?? this.assessment?.assessmentTemplateId ?? null;
	}

	get phaseBadgeText(): string | null {
		const api = this.assessment?.question?.phase?.shortLabel;
		if (api != null && String(api).trim() !== '') {
			return String(api).trim();
		}
		const raw = this.assessment?.question?.phase?.sortOrder ?? this.assessment?.question?.phaseNumber;
		if (raw == null || String(raw).trim() === '') return null;
		const n = Number(raw);
		if (!Number.isFinite(n) || n <= 0) return null;
		return `P ${Math.floor(n)}`;
	}

	get phaseAccentHex(): string | null {
		const raw = this.assessment?.question?.phase?.color;
		if (raw != null && String(raw).trim() !== '') {
			return String(raw).trim();
		}
		return null;
	}

	get templateBadgeText(): string | null {
		const tid = this.resolveAssessmentTemplateId();
		if (tid == null) return null;
		const s = String(tid).trim();
		return s ? `T${s}` : null;
	}

	public scoreRubric = PARA_SCORE_RUBRIC;

	public getScoreColor(score: any): string {
		return paraScoreFillHex(score) ?? 'transparent';
	}

	public getScoreFaintColor(score: any): string {
		return paraScoreTintHex(score, '1A') ?? 'transparent';
	}

	public getScoreTextColor(score: any): string {
		return paraScoreTextHex(score);
	}

	onRemove(): void {
		this.deleteScore.emit(this.storageKey);
	}

	onRescore(): void {
		this.rescore.emit(this.storageKey);
	}

	constructor() {}

	ngOnInit(): void {}
}
